import React from 'react';
import PageToolbar from './PageToolbar';

/**
 * ContextToolbar — page-scoped command strip below the global shell bar (Shell Target Spec v1.0).
 * Left: leading + title stack · Center: filters (optional) · Right: actions.
 */
const ContextToolbar = ({
  leading,
  eyebrow,
  title,
  subtitle,
  meta,
  center,
  actions,
  children,
  sticky = false,
  className = '',
  titleAs: TitleTag = 'h1',
}) => {
  const hasText = Boolean(eyebrow || title || subtitle || meta);
  const hasStart = Boolean(leading || hasText);
  const hasEnd = Boolean(actions || children);
  const hasCenter = Boolean(center);
  if (!hasStart && !hasEnd && !hasCenter) return null;

  return (
    <PageToolbar
      split
      align="start"
      className={[
        'ads-context-toolbar',
        sticky ? 'ads-context-toolbar--sticky' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {hasStart ? (
        <div className="ads-context-toolbar__start">
          {leading}
          {hasText ? (
            <div className="ads-context-toolbar__titles">
              {eyebrow ? (
                <p className="ads-context-toolbar__eyebrow ads-type-context-eyebrow">{eyebrow}</p>
              ) : null}
              {title ? (
                <TitleTag className="ads-context-toolbar__title ads-type-context-title">{title}</TitleTag>
              ) : null}
              {subtitle ? (
                <p className="ads-context-toolbar__subtitle ads-type-context-subtitle">{subtitle}</p>
              ) : null}
              {meta ? <div className="ads-context-toolbar__meta">{meta}</div> : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {hasCenter ? <div className="ads-context-toolbar__center">{center}</div> : null}
      {hasEnd ? (
        <div className="ads-context-toolbar__actions">{actions ?? children}</div>
      ) : null}
    </PageToolbar>
  );
};

export default ContextToolbar;
